import { Component, ElementRef, Input } from '@angular/core';


@Component({
  selector: 'app-error-tooltip',
  templateUrl: './error-tooltip.component.html',
  styleUrls: ['./error-tooltip.component.css']
})
export class ErrorTooltipComponent {
  @Input() message: string = '';
  @Input() show: boolean = false;
  @Input() type: 'pulse' | 'question' = 'pulse';




}
